/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetFifoPnl } from './assetFifoPnl';

export interface FifoPnlResult {
  accountId?: number;
  fromTime?: string;
  toTime?: string;
  lastProcessedTime?: string;
  assetFifoPnls?: Array<AssetFifoPnl>;
  reportId?: number;
  errorMessage?: string;
  done?: boolean;
}
